import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { serverEndPoint } from '../../actions/Utils';
import { Grid, Typography, Modal, Backdrop, Fade, makeStyles } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faChevronLeft, faBirthdayCake, faBell } from '@fortawesome/free-solid-svg-icons';
import { getBirthdays, getLocaleAndWeather, getUsers } from '../../actions/Auth';
import { getLink, setLinkMaisMaerv } from '../../actions/System';
import { getHomeBanners } from '../../actions/Banners';
import { GetDayofWeek, FormatDay, GetMonthName, GreetingsMessage, getWeatherIcon } from '../../Utils';
import Communicated from '../Communicated';
import Contracts from '../Contracts';
import { getSecureTexts } from '../../actions/SecureText';


import NotificationTable from '../common/NotificationTable';
import { ModalAction } from '../common/Modal';

import '../../../node_modules/slick-carousel/slick/slick.css';
import '../../../node_modules/slick-carousel/slick/slick-theme.css';

import btManserv from '../../assets/img/bt_prezi.png';
import btManservHover from '../../assets/img/bt_prezi_over.png';
import btMais from '../../assets/img/bt_mais.png';
import btMaisHover from '../../assets/img/bt_mais_over.png';
import btMarca from '../../assets/img/bt_marca_off.png';
import btMarcaHover from '../../assets/img/bt_marca_on.png';

import img1 from '../../assets/img/5891_EDI_ok.png';
import img2 from '../../assets/img/adm_fem.png';
import img3 from '../../assets/img/cara_compliance.png';
// import PopupImage from '../../assets/img/pop_up_intranet_inativacao.png'

import { userLogout } from '../../actions/Auth';

import {
  Image,
  SlickSlider,
  MiniBanner,
  MiniBannerImg,
  MiniBannerText,
  MiniBannersArea,
  WelcomeBanner,
  WelcomeText,
  CurrentDate,
  CurrentTime,
  CurrentTemperature,
  CurrentLocation,
  BoxTitle,
  BirthDayTitle,
  List,
  BirthDayList,
  ManServBanner,
  ButtonsBannerGrid,
  IconBanner,
  NameBirthday,
  StyledDivider,
  InformativeDivider,
  StyledIconButton,
} from './style';

const Home = ({ history }) => {
  // const useStyles = makeStyles((theme) => ({
  //   modal: {
  //     display: 'flex',
  //     alignItems: 'center',
  //     justifyContent: 'center',
  //   },
  //   paper: {
  //     width: 700,
  //     height: 500,
  //     outline: 'none',
  //     borderRadius: 8,
  //     overflow: 'hidden',
  //     boxShadow: theme.shadows[5],
  //   },
  //   image: {
  //     width: '100%',
  //     height: '100%',
  //     objectFit: 'cover',
  //     display: 'block',
  //   },
  // }));

  const [secureText, setSecureText] = useState('');

  // const [openPopUp, setOpenPopUp] = useState(false);
  // const classes = useStyles();

  const dispatch = useDispatch();
  const [modalOpen, setModalOpen] = useState({
    open: false,
    type: null,
  });
  const [date, setDate] = useState(new Date());
  const [eadHover, setEadHover] = useState(false);
  const [preziHover, setPreziHover] = useState(false);
  const [maisHover, setMaisHover] = useState(false);
  const [marcaHover, setMarcaHover] = useState(false);
  const [linkMaisManserv, setLinkmais] = useState('');

  const { birthDays, weather, banners, notifications, cpf, hasLog, ...rest } = useSelector(({ auth, banners, system }) => ({
    birthDays: auth?.birthDays || [],
    weather: auth?.weatherLocale || [],
    banners: banners?.homeBanners || [],
    notifications: auth?.notifications || [],
    cpf: auth?.userData?.cpf || [],
    linkMaisManserv: system?.linkMaisManserv,
    hasLog: auth?.userData?.userLogado?.has_log || undefined
  }));

  // useEffect(() => {
  //   setOpenPopUp(true);
  // }, []);

  useEffect(() => {
    dispatch(getUsers(hasLog));
    dispatch(getHomeBanners());
    dispatch(getLocaleAndWeather());
    dispatch(getSecureTexts());
    getLinkMaisManserv(notifications)
  }, []);

  useEffect(() => {
    if (!birthDays.length) dispatch(getBirthdays());
    getLinkMaisManserv()
  }, [birthDays]);

  useEffect(() => {
    let timerID = setInterval(() => setDate(new Date()), 1000);

    return function cleanup() {
      clearInterval(timerID);
    };
  }, []);

  useEffect(() => {
    // setInterval(async()=>{handleMensagem()},10000)
    handleMensagem()
  }, []);

  const handleMensagem = async () => {
    let resp = await axios.get(`${serverEndPoint}/secure/getSecureTexts`);
    console.log(resp.data)
    let mensagens = resp.data.filter((m) => {
      return m.active === 1;
    })
    let index = Math.floor(Math.random() * (mensagens.length - 0) + 0)
    setSecureText(mensagens[index]?.text_box ?? '')
  }

  useEffect(() => {
    handleLogin()
  }, []);

  const handleLogin = async () => {
    try {
      const { data, status } = await axios.post(`${serverEndPoint}/secure/verificaComunica`, cpf);

      console.log(data)
      console.log(status)

      if (status === 200) {
        console.log("OK - ", status)
      }
      
    } catch (error) {
      console.log(error)
      dispatch(userLogout()).then(history.push('/Login'));
    }
  }

  async function getLinkMaisManserv() {
    if (!rest?.linkMaisManserv) {

      try {
        const response = await getLink()
        const filterSortDesc = response.sort(function (x, y) {
          let a = new Date(x.documentId)
          let b = new Date(y.documentId)

          return b - a
        });
        setLinkmais(filterSortDesc[0])
        dispatch(setLinkMaisMaerv(filterSortDesc[0]));
      } catch (error) {

        setLinkmais({
          documentId: '3036239',
          version: '1000'
        })

        dispatch(setLinkMaisMaerv({
          documentId: '3036239',
          version: '1000'
        }));
      }
    } else {
      setLinkmais(rest?.linkMaisManserv?.linkMaisManserv)
    }
  }


  const BackButton = ({ currentSlide, slideCount, ...props }) => (
    <FontAwesomeIcon
      {...props}
      className={'slick-prev slick-arrow' + (currentSlide === 0 ? ' slick-disabled' : '')}
      aria-disabled={currentSlide === 0 ? true : false}
      icon={faChevronLeft}
    />
  );
  const NextButton = ({ currentSlide, slideCount, ...props }) => (
    <FontAwesomeIcon
      {...props}
      className={'slick-next slick-arrow' + (currentSlide === 0 ? ' slick-disabled' : '')}
      aria-disabled={currentSlide === 0 ? true : false}
      icon={faChevronRight}
    />
  );

  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 5000,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: <BackButton />,
    nextArrow: <NextButton />,
  };

  const columns = [
    { id: 'processDescription', label: 'Descrição', minWidth: '250px' },
    { id: 'documentDescription', label: 'Data', minWidth: '160px' },
  ];

  const miniBanners = [
    {
      image: img3,
      action: () => window.open('https://se.manserv.com.br/se/document/dc_view_document/api_view_document.php?cddocument=4892&nmfile=M-00016_V8_C%F3digo_de_%C9tica.pdf', '_blank').focus(),
      label: (
        <MiniBannerText style={{ fontSize: '19px' }}>
          Código de <br /> Conduta e Ética
        </MiniBannerText>
      ),
    },
    {
      image: img1,
      action: () => handleOpen('cont'),
      label: (
        <MiniBannerText style={{ fontSize: '19px' }}>
          Novos <br /> Contratos
        </MiniBannerText>
      ),
    },
    {
      image: img2,
      // action: () => handleOpen('comms'),
      action: () => window.open('https://se.manserv.com.br/softexpert/workspace?page=108084,104'),
      label: (
        <MiniBannerText style={{ fontSize: '19px' }}>
          Solicitação de Comunicado Interno
        </MiniBannerText>
      ),
    },
  ];

  const handleOpen = (type) => {
    setModalOpen({ open: true, type: type });
  };

  const handleClose = () => {
    setModalOpen({ open: false, type: null });
  };



  return (
    <>
      <Grid container>
        <Grid item md={7} xs={12}>
          <SlickSlider {...settings}>
            {banners?.map((i, index) => {
              return (
                <div key={index} onClick={() => i?.url && window.open(i?.url, '_blank').focus()}>
                  <Image src={i?.img} />
                </div>
              );
            })}
          </SlickSlider>
          <MiniBannersArea container spacing={6}>
            {miniBanners.map((i, index) => {
              return (
                <Grid key={index} item sm={4} xs={12}>
                  <MiniBanner onClick={i.action}>
                    {i.label}
                    <MiniBannerImg src={i.image} />
                  </MiniBanner>
                </Grid>
              );
            })}
          </MiniBannersArea>

          {/*Item Novo*/}

          <span style={{
            width: "90%",
            display: "flex",
            justifyContent: "center",
            fontSize: "21px",
            fontWeight: "bold",
            fontFamily: "IBM Plex Sans,sans-serif",
            padding: "10px",
            backgroundColor: "#fff",
            marginLeft: "15px",
            border: "2px solid #ff450a"
          }}>{secureText}</span>

          {/* <div id="comunitysArea">
          </div> */}
          {/* <iframe src={`https://intranetelggdev.manserv.com.br/intranetelggdev/comunidades/?userLogin=${cpf}`} style={{ width: '100%', height: '380px' }} /> */}
        </Grid>
        <Grid item md={5} xs={12}>
          <WelcomeBanner>
            <Grid container>
              <Grid item md={4} sm={4} xs={4}>
                <WelcomeText>{GreetingsMessage(date.toLocaleTimeString())}</WelcomeText>
                <CurrentDate>{`${GetDayofWeek(date.getDay())}, ${FormatDay(date.getDate())} de ${GetMonthName(date.getMonth())}`}</CurrentDate>
                <CurrentTime>{date.toLocaleTimeString().slice(0, -3)}</CurrentTime>
                <CurrentTemperature>
                  <FontAwesomeIcon icon={getWeatherIcon(weather.tempIcon)} />
                  {weather?.temp ?? ''}ºC
                </CurrentTemperature>
                <CurrentLocation>{weather?.locale ?? 'Carregando...'}</CurrentLocation>
              </Grid>
              <StyledDivider orientation="vertical" flexItem />
              <BirthDayList item md={8} sm={8} xs={8}>
                <BoxTitle>
                  <BirthDayTitle>Feliz Aniversário</BirthDayTitle>
                  <StyledIconButton onClick={() => history.push('/Aniversarios')}>
                    <FontAwesomeIcon icon={faBirthdayCake} />
                  </StyledIconButton>
                </BoxTitle>
                <List>
                  {birthDays?.length ? (
                    birthDays.map((b, index) => {
                      return (
                        <li key={index} style={{ alignItems: 'center', display: 'flex' }}>
                          <FontAwesomeIcon icon={faChevronRight} />
                          <NameBirthday>{b.name}</NameBirthday>
                        </li>
                      );
                    })
                  ) : (
                    <li style={{ alignItems: 'center', display: 'flex' }}>
                      <FontAwesomeIcon icon={faChevronRight} />
                      <NameBirthday>Carregando...</NameBirthday>
                    </li>
                  )}
                </List>
              </BirthDayList>
            </Grid>
          </WelcomeBanner>
          <ManServBanner>
            <Grid container style={{ backgroundColor: '#ededed' }}>
              <ButtonsBannerGrid
                onMouseEnter={() => setMarcaHover(true)}
                onMouseLeave={() => setMarcaHover(false)}
                onClick={() => window.open('https://tiadminmanserv.sharepoint.com/sites/Marketing', '_blank').focus()}
                border={1}
                item
                xs={4}
              >
                <IconBanner>
                  <img src={marcaHover ? btMarcaHover : btMarca} />
                  {/* <img src={eadHover ? btEadHover : btEad} /> */}
                </IconBanner>
                <Typography style={{ lineHeight: '1.3' }}>
                  Nossa Marca, <br /> Identidade e Padrões
                </Typography>
              </ButtonsBannerGrid>
              <InformativeDivider orientation="vertical" flexItem />
              <ButtonsBannerGrid
                style={{
                  ...(linkMaisManserv == '' ? {
                    cursor: 'auto',
                    background: 'white',
                    opacity: 0.5
                  } : {}),
                }}
                onMouseEnter={() => setMaisHover(true)}
                onMouseLeave={() => setMaisHover(false)}
                onClick={() => window.open(`https://tiadminmanserv.sharepoint.com/sites/marketingecomunicacao`, '_blank').focus()}
                item
                xs={4}
              >
                <IconBanner>
                  <img src={maisHover ? btMaisHover : btMais} />
                </IconBanner>
                <Typography style={{ lineHeight: '1.3' }}>
                  Conteúdos para <br /> Gestão à Vista
                </Typography>
              </ButtonsBannerGrid>
              <InformativeDivider orientation="vertical" flexItem />
              <ButtonsBannerGrid
                onMouseEnter={() => setPreziHover(true)}
                onMouseLeave={() => setPreziHover(false)}
                onClick={() => window.open('https://tiadminmanserv.sharepoint.com/:f:/s/Marketing/EuyNIfDFncFOvcxEK1965rsBN4FvR6flKttS5NbUDZVlNQ?e=Ib4UNo', '_blank').focus()}
                item
                xs={4}
              >
                <IconBanner>
                  <img src={preziHover ? btManservHover : btManserv} />
                </IconBanner>
                <Typography style={{ lineHeight: '1.3' }}>
                  Apresentação <br /> Institucional
                </Typography>
              </ButtonsBannerGrid>
            </Grid>
          </ManServBanner>
          <WelcomeBanner>
            <BoxTitle>
              <BirthDayTitle style={{ paddingLeft: '10px' }}>Notificações</BirthDayTitle>
              <StyledIconButton onClick={() => handleOpen('not')}>
                <FontAwesomeIcon icon={faBell} />
              </StyledIconButton>
            </BoxTitle>
            {notifications.filter(item => item != null).length > 0 ? <NotificationTable columns={columns} rows={notifications || []} /> :
              <Typography style={{ paddingLeft: 10, lineHeight: '1.3', fontFamily: 'IBMPlexSans-SemiBold' }}>
                Sem notificações
              </Typography>}
          </WelcomeBanner>
        </Grid >

        {/* <Modal
          className={classes.modal}
          open={openPopUp}
          onClose={() => setOpenPopUp(false)}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Fade in={openPopUp}>
            <div className={classes.paper}>
              <img
                src={PopupImage}
                alt="Aviso Intranet"
                className={classes.image}
              />
            </div>
          </Fade>
        </Modal> */}

      </Grid >
      <ModalAction
        title={(modalOpen.type === 'not' && 'Notificações') || (modalOpen.type === 'cont' && 'Novos Contratos') || (modalOpen.type === 'comms' && 'Central de Comunicados')}
        open={modalOpen?.open}
        backAction={() => handleClose()}
      >
        {modalOpen.type === 'not' && <NotificationTable columns={columns} rows={notifications || []} />}
        {modalOpen.type === 'comms' && <Communicated />}
        {modalOpen.type === 'cont' && <Contracts />}
      </ModalAction>
    </>
  );
};

export default Home;
